import {Hero} from '@primer/react-brand'

import {getImageSources, MAX_CONTENT_WIDTH} from '@github-ui/swp-core/lib/utils/images'

import {AssetTypeEnum} from '../../types'
import {AssetVideo} from '../Video'
import type {FlexSuiteFiftyFiftyHeroProps} from './types'
import {HeroContent} from './HeroContent'

/**
 * 50/50 hero: content on one side with an inline-end-padded image (or video)
 * on the other. Modeled on Primer Brand's `GridlineImageInlineEndPadded`
 * gridline variant.
 */
export function FlexSuiteHero5050({fields}: {fields: FlexSuiteFiftyFiftyHeroProps}) {
  const {heroAsset} = fields
  const {assetType, optionImage, optionVideo, optionPoster, autoplay, videoSource} = heroAsset?.fields ?? {}

  return (
    <HeroContent {...fields} data-testid="hero-50-50">
      {assetType === AssetTypeEnum.enum.Image && optionImage && (
        <Hero.Image
          as="picture"
          position="inline-end-padded"
          src={`${optionImage.fields.file.url}?fm=webp`}
          sources={getImageSources(optionImage.fields.file.url, {
            maxWidth: MAX_CONTENT_WIDTH / 2,
          })}
          alt={optionImage.fields.description ?? ''}
        />
      )}
      {assetType !== AssetTypeEnum.enum.Image && (optionVideo || videoSource) && (
        <Hero.Video position="inline-end-padded">
          <AssetVideo
            assetType={assetType}
            optionVideo={optionVideo}
            optionPoster={optionPoster}
            autoplay={autoplay}
            videoSource={videoSource}
          />
        </Hero.Video>
      )}
    </HeroContent>
  )
}
